import { Skeleton, Space } from "antd";
import { useEffect, useState } from "react";
import { useAuth } from "src/core/hooks/useAuth";
import { RecapDataManager } from "src/modules/PriceConfiguratorManager/components/DataSectionManager/sections/Recap/components/RecapDataManager";
import { DataSectionData } from "src/types/priceConfigurator";

type Props = {
  dataSection: DataSectionData;
};

export const Recap: React.FC<Props> = (props: Props) => {
  const { dataSection } = props;

  const { success, authLoaded } = useAuth();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (authLoaded && success) {
        setLoading(false);
      }
    })();
  }, [authLoaded, success]);

  return (
    <Space
      direction="vertical"
      size={0}
      style={{ marginBottom: 50, minWidth: 600 }}
      className="full-width-space"
    >
      <Skeleton
        loading={loading}
        active
        style={{ minHeight: 200, minWidth: 200 }}
      >
        <RecapDataManager dataSection={dataSection} />
      </Skeleton>
    </Space>
  );
};
